module.exports = "/assets/data/600bb585e52da8de37207e7578d821d1-WS12.data.json";